import _ from "lodash";
import { AttributeConstraint } from "../types/ConstraintsTypes";
import { ProductConstraints } from "@vp/hamilton-service-clients/dist/src/types/Constraints";
import { MerchandisingProductView } from "../types/ContentfulTypes";
import { MpvProvider } from "../utils/MpvProvider";

const buildAttributeConstraints = (
  pastaResponse: ProductConstraints[],
  mpv: MerchandisingProductView
): {
  attributeConstraints: AttributeConstraint[];
  outOfStock?: boolean;
} => {
  let outOfStock;
  let hasQuantityConstraint;
  const attributeConstraints: AttributeConstraint[] = [];
  const mpvProvider = new MpvProvider(mpv);

  pastaResponse.forEach(productConstraint => {
    const attributeConstraint: AttributeConstraint = {};

    if (productConstraint.constraint === null) {
      outOfStock = true;
    }

    for (const constraint of productConstraint?.constraint?.range || []) {
      // If the constraint is quantity-related, we can ignore it
      // Merchandised quantities endpoint handles this logic & we do not need to indicate out of stock quantities
      if (constraint.name === "Quantity") {
        hasQuantityConstraint = true;
        return;
      }

      attributeConstraint[constraint.name] = constraint.ranges;
    }

    productConstraint.constraint?.list?.forEach(constraint => {
      // If there is only ONE attribute AND every value in that attribute is specified the entire product is disabled
      if (
        productConstraint.constraint.list.length === 1 &&
        constraint.values.length === mpvProvider.getValuesOfOption(constraint.name).length
      ) {
        outOfStock = true;
      }

      attributeConstraint[constraint.name] = constraint.values;
    });

    if (!_.isEmpty(attributeConstraint)) attributeConstraints.push(attributeConstraint);
  });

  // If the service returns something, but there are no constaints, the entire product is disabled
  if (attributeConstraints.length === 0 && !hasQuantityConstraint) {
    outOfStock = true;
  }

  return { attributeConstraints, outOfStock };
};

export { buildAttributeConstraints };
